import { create } from 'zustand';
import { getCookie, setCookie } from '@lib/cookie';

export interface OfficeState {
  isConnectSlide: boolean;
  setIsConnectSlide: (value: boolean) => void;

  isStreamActive: boolean;
  setIsStreamActive: (value: boolean) => void;

  officeReady: boolean;
  setOfficeReady: (value: boolean) => void;

  officeError: any;
  setOfficeError: (value: any) => void;

  isLoading: boolean;
  setIsLoading: (value: boolean) => void;

  activeView: any;
  setActiveView: (value: any) => void;

  isPowerpoint: boolean;
  setIsPowerpoint: (value: boolean) => void;

  isPowerpointDesktop: boolean;
  setIsPowerpointDesktop: (value: boolean) => void;

  isPowerpointOnline: boolean;
  setIsPowerpointOnline: (value: boolean) => void;

  refreshSettingsAsync: () => Promise<any>;
  getSettings: (key: string) => Promise<any>;
  saveSettings: (key: string, value: any) => Promise<void>;
  getLastRoutePath: () => Promise<string>;
}

export const useOfficeStore = create<OfficeState>()((set, get) => ({
  isConnectSlide: false,
  setIsConnectSlide: (isConnectSlide) => set({ isConnectSlide }),

  isStreamActive: false,
  setIsStreamActive: (isStreamActive) => set({ isStreamActive }),

  officeReady: false,
  setOfficeReady: (officeReady) => set({ officeReady }),

  officeError: null,
  setOfficeError: (officeError) => set({ officeError }),

  isLoading: true,
  setIsLoading: (isLoading) => set({ isLoading }),

  activeView: null,
  setActiveView: (activeView) => set({ activeView }),

  isPowerpoint: typeof window !== 'undefined' ? !!getCookie('isPowerpoint') : false,
  setIsPowerpoint: (value) => {
    setCookie('isPowerpoint', String(value));
    set({ isPowerpoint: value });
  },

  isPowerpointDesktop: false,
  setIsPowerpointDesktop: (isPowerpointDesktop) => set({ isPowerpointDesktop }),

  isPowerpointOnline: false,
  setIsPowerpointOnline: (isPowerpointOnline) => set({ isPowerpointOnline }),

  refreshSettingsAsync: () =>
    new Promise((resolve) => {
      (window as any).Office.context.document.settings.refreshAsync((r: any) => {
        resolve(r);
      });
    }),

  getSettings: async (key) => {
    await get().refreshSettingsAsync();
    const settings = (window as any).Office.context.document.settings;
    return settings.get(key);
  },

  saveSettings: async (key, value) => {
    await get().refreshSettingsAsync();
    const settings = (window as any).Office.context.document.settings;
    settings.set(key, value);
    return await new Promise((resolve, reject) => {
      settings.saveAsync((result: any) => {
        if (result.status !== (window as any).Office.AsyncResultStatus.Succeeded) {
          reject(result.error);
        } else {
          resolve(result);
        }
      });
    });
  },

  getLastRoutePath: async () => {
    const lastRoute = await get().getSettings('lastRoute');
    console.log('Retrieved last route:', lastRoute);
    if (lastRoute) return lastRoute;
    return '/interaction-links';
  },
}));
